import graphics1 from "../../images/tokenomics.png";

export const graphicsData1 = {
  img: graphics1,
  alt: "Token",
  heading: "Token Economy",
  title: "for All Participants",
};
